import Dashboard from './Dashboard'
import Analytics from './Analytics'
import UserProfile from './UserProfile'

export { Dashboard, Analytics, UserProfile }
